
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Livello_2","data-name":"Livello 2"}},[_c('g',{attrs:{"id":"Livello_1-2","data-name":"Livello 1"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h40v40H0z"}}),_c('path',{attrs:{"id":"generic-delete","fill":"#63707F","d":"M20 1.22A18.78 18.78 0 1038.78 20 18.78 18.78 0 0020 1.22zm7.41 23.37a2 2 0 11-2.82 2.82L20 22.83l-4.59 4.58a2 2 0 01-2.82-2.82L17.17 20l-4.58-4.59a2 2 0 012.82-2.82L20 17.17l4.59-4.58a2 2 0 012.82 2.82L22.83 20z"}})])])])
          )
        }
      }
    